const validateSingleSchedule = (rule) => {
    const errors = [];

    if (!rule.day.enabled && !rule.device.enabled && !rule.time.enabled) {
        errors.push({
            id: rule.id,
            type: 'no-condition',
            message: `Rule ${`"${rule.name}"` || rule.id} has no conditions enabled.`
        });
    };

    if (rule.device.enabled && !rule.device.value) {
        errors.push({
            id: rule.id,
            type: 'invalid-device',
            message: `Rule ${`"${rule.name}"` || rule.id} has device enabled with no value.`
        });
    };

    if (rule.day.enabled && rule.day.value.length < 1) {
        errors.push({
            id: rule.id,
            type: 'invalid-day',
            message: `Rule ${`"${rule.name}"` || rule.id} has day enabled with no days selected.`
        });
    };

    if (rule.time.enabled) {
        const toMinutes = t => {
            const [h, m] = t.split(':').map(Number);
            return h * 60 + m;
        };
        if (!rule.time.value.start || !rule.time.value.end) {
            errors.push({
                id: rule.id,
                type: 'invalid-time',
                message: `Rule ${`"${rule.name}"` || rule.id} has incomplete time values.`
            });
        } else if (toMinutes(rule.time.value.start) >= toMinutes(rule.time.value.end)) {
            errors.push({
                id: rule.id,
                type: 'invalid-range',
                message: `Rule ${`"${rule.name}"` || rule.id} has an invalid time range.`
            });
        };
    };

    if (!rule.resources || rule.resources.data.length === 0) {
        errors.push({
            id: rule.id,
            type: 'no-resource',
            message: `Rule ${`"${rule.name}"` || rule.id} has no resources.`
        });
    };

    return errors;
};

const hasConflict = (rule1, rule2) => {
    if (rule1.id === rule2.id) return { hasConflict: false };
    
    const conflicts = {
        day: {
            conflict: rule1.day.enabled === rule2.day.enabled,
            message: '',
        },
        device: {
            conflict: rule1.device.enabled === rule2.device.enabled,
            message: '',
        },
        time: {
            conflict: rule1.time.enabled === rule2.time.enabled,
            message: '',
        },
    };

    if (rule1.time.enabled && rule2.time.enabled) {
        if (rule1.time.value.timezone === 'device-tz' || rule2.time.value.timezone === 'device-tz') {
            conflicts.time.conflict = true;
        } else {
            const toDate = (time, timezone) => {
                const [h, m] = time.split(':').map(Number);
                const d = new Date();
                const dateInTz = new Date(d.toLocaleString('en-US', { timeZone: timezone }));
                dateInTz.setHours(h, m, 0, 0);
                return dateInTz.getTime();
            };

            const timezone1 = rule1.time.value.timezone;
            const timezone2 = rule2.time.value.timezone;

            const start1 = toDate(rule1.time.value.start, timezone1);
            const end1 = toDate(rule1.time.value.end, timezone1);
            const start2 = toDate(rule2.time.value.start, timezone2);
            const end2 = toDate(rule2.time.value.end, timezone2);

            if (start1 < end2 && start2 < end1) {
                conflicts.time.message = `${`"${rule1.name}"` || rule1.id} has time overlap with ${`"${rule2.name}"` || rule2.id}`;
            } else {
                conflicts.time.conflict = false;
            };
        };
    };

    if (rule1.device.enabled && rule2.device.enabled) {
        if (rule1.device.value === rule2.device.value) {
            conflicts.device.message = `${`"${rule1.name}"` || rule1.id} device matches ${`"${rule2.name}"` || rule2.id}`;
        } else {
            conflicts.device.conflict = false;
        };
    };

    if ((rule1.day.enabled && rule2.day.enabled)) {
        if (rule1.day.value.some(d => rule2.day.value.includes(d))) {
            conflicts.day.message = `${`"${rule1.name}"` || rule1.id} has conflicting days from ${`"${rule2.name}"` || rule2.id}`;
        } else {
            conflicts.day.conflict = false;
        };
    };

    return {
        hasConflict: (conflicts.device.conflict && conflicts.day.conflict && conflicts.time.conflict),
        reason: conflicts.time.message || conflicts.day.message || conflicts.device.message || '',
    };
};

export const validateSchedule = (schedules, activeSchedule) => {
    let errors = [];
    const scheduleArray = Object.values(schedules);

    if (activeSchedule) {
        const currentRule = schedules[activeSchedule];
        if (!currentRule) {
            return errors;
        };

        errors = errors.concat(validateSingleSchedule(currentRule));

        for (const rule of scheduleArray) {
            const conflictResults = hasConflict(currentRule, rule);

            if (conflictResults.hasConflict) {
                errors.push({
                    id: currentRule.id,
                    type: 'overlap',
                    message: conflictResults.reason || `Rule ${`"${currentRule.name}"` || currentRule.id} conflicts with rule ${`"${rule.name}"` || rule.id}`,
                });
            };
        };
    } else {
        for (let i = 0; i < scheduleArray.length; i++) {
            const rule1 = scheduleArray[i];

            errors = errors.concat(validateSingleSchedule(rule1));

            for (let j = i + 1; j < scheduleArray.length; j++) {
                const rule2 = scheduleArray[j];
                const conflictResults = hasConflict(rule1, rule2);

                if (conflictResults.hasConflict) {
                    errors.push({
                        id: rule1.id,
                        type: 'overlap',
                        message: conflictResults.reason || `Rule ${`"${rule1.name}"` || rule1.id} conflicts with rule ${`"${rule2.name}"` || rule2.id}`,
                    });
                };
            };
        };
    };

    return errors;
};